module.exports = __webpack_public_path__ + "static/media/icon-search.af77bd14.svg";